import React, { Component } from 'react';
import TaskService from '../service/taskService';
import TaskStatusService from "../service/taskStatusService";
import "../design/projecttasks.css";
import NavigationBar from '../components/navigationBar';
import TaskTypeService from '../service/taskTypeService';

export default class ProjectTasks extends Component {

    constructor(props) {
        super(props);
        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.taskTypeService = new TaskTypeService();
        this.state = {
            tasks: [],
            taskStatuses: [],
            TaskTitle: "",
            TaskDescription: "",
            NoRedirect: false,
            SubmittingTask: false,
            tasktypes: [],
            selectedTaskType: 0
        }
        this.handleRedirectToTask = this.handleRedirectToTask.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    }

    async getTasks() {
        let result = await this.taskService.retrieveTasks(this.props.match.params.projectID)
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasks: result
            })
        }
    }
    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    handleCheckBoxChange() {
        this.setState({
            NoRedirect: !this.state.NoRedirect
        })
    }

    async onSubmitClick(event) {
        event.preventDefault();
        this.setState({
            SubmittingTask: true
        })

        let results = await this.taskService.createTask(this.props.match.params.projectID, this.state.TaskTitle, this.state.TaskDescription, this.state.selectedTaskType);
        if (results.statuscode === 200) {
            if (!this.state.NoRedirect) {
                this.hideOverlay();
            }
            else {
                alert("Your task \"" + this.state.TaskTitle + "\" have been created");
                this.setState({
                    TaskTitle: "",
                    TaskDescription: "",
                    SubmittingTask: false
                })
            }
            this.getTasks();

        }
        else if (results.statuscode === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("Your task have not been created. Error code: " + results.body.code + "Error message:" + results.body.message);
            this.setState({
                SubmittingTask: false
            })
        }
    }

    async getTaskTypes() {
        let result = await this.taskTypeService.getTaskTypes();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasktypes: result
            })
        }
    }

    componentDidMount() {
        document.title = "Task Overview"
        this.getTasks();
        this.getTaskStatuses();
        this.getTaskTypes();
    }

    handleRedirectToTask(event, taskUUID) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.match.params.projectID + "/Task/" + taskUUID, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.match.params.projectID + "/Task/" + taskUUID);
        }
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }


    render() {
        const tasks = this.state.tasks;
        if (!tasks) return null;
        const taskStatuses = this.state.taskStatuses;
        if (taskStatuses.length === 0) return null
        const tasktypes = this.state.tasktypes;
        if (tasktypes.length === 0) return null;

        return (
            <div className="body">

                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Task</h1></center>
                        <form action="#" onSubmit={(event) => { this.onSubmitClick(event) }}>
                            <select name="selectedTaskType" id="selectedTaskType" onChange={this.handleChange} value={this.state.taskTypeStatus}>
                                {tasktypes.map(tasktype => (
                                    <option value={tasktype.typeId} key={tasktype.typeId}>{tasktype.typeName}</option>
                                ))}
                            </select><br />
                            <label htmlFor="TaskTitle"><b>Title:</b></label><br />
                            <input type="text" name="TaskTitle" value={this.state.TaskTitle} onChange={this.handleChange} required /><br />
                            <label htmlFor="TaskDescription"><b>Description:</b></label><br />
                            <textarea name="TaskDescription" id="TaskDescription" value={this.state.TaskDescription} onChange={this.handleChange} cols="50" rows="4"></textarea><br />
                            <label htmlFor="NoRedirect"><b>Create Multiple:</b></label>
                            <input type="checkbox" name="NoRedirect" defaultChecked={this.state.NoRedirect} onChange={() => this.handleCheckBoxChange()} /><br />
                            <button type="submit" disabled={this.state.SubmittingTask}>Create Task</button>
                        </form>
                    </div>
                </div>

                <NavigationBar {...this.props} />

                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <table>
                        <thead>
                            <tr>
                                <td>Task name</td>
                                <td>Task Status</td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.tasks.map((task) => (
                                <tr className="tr_hover"
                                    key={task.taskUUID}
                                    onClick={(event) => { this.handleRedirectToTask(event, task.taskUuid) }}
                                >
                                    <td>{task.taskTitle}</td>
                                    <td>{taskStatuses.find(element => element.taskStatusID === task.taskStatus).statusName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/projecttasks.js